import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import stoneBg from "@/assets/stone-bg.webp";
import logo from "@/assets/logo.webp";

// Preload critical LCP assets (background + logo) as early as possible
const preloads: Array<{ href: string; as: string; type?: string; fetchpriority?: string }> = [
  { href: stoneBg, as: "image", fetchpriority: "high" },
  { href: logo, as: "image", fetchpriority: "high" },
];
for (const p of preloads) {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = p.as;
  link.href = p.href;
  if (p.fetchpriority) link.setAttribute("fetchpriority", p.fetchpriority);
  document.head.appendChild(link);
}

createRoot(document.getElementById("root")!).render(<App />);
